export default __webpack_public_path__ + "static/media/bano-desktop.9b9db9d5.jpg";